import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/index.css';
import Brand from '../components/Brand';
import SEO from '../components/SEO';

const About: React.FC = () => {
  const navigate = useNavigate();
  const goToDemo = () => navigate('/request-demo');

  return (
    <div className="home-container">
      <SEO
        title="About OpenUse"
        description="OpenUse is an operational software company in San Mateo, CA, building SupplyMD, OpenRFQ, AInventory, and ATracker for regulated, high-stakes industries."
        path="/about"
      />
      <div className="hero-section solutions-hero">
        <div className="hero-content">
          <p className="hero-eyebrow">
            About <Brand />
          </p>
          <h1 className="hero-headline">
            We build the operational systems regulated industries depend on.
          </h1>
          <p>
            <Brand /> is an operational software company headquartered in San
            Mateo, California. Our platform powers SupplyMD, OpenRFQ,
            AInventory, and ATracker &mdash; four products used by healthcare,
            procurement, inventory-driven, and asset-heavy teams to run the
            work that has to be right.
          </p>
        </div>
      </div>

      <section className="story-section">
        <h2 className="section-title">Our mission</h2>
        <p className="mission-statement">
          To put operational software that meets enterprise standards within
          reach of every team responsible for the work that has to be right.
        </p>
      </section>

      <section className="story-section">
        <h2 className="section-title">Founder story</h2>
        <div className="story-content">
          <p>
            <Brand /> was founded after years spent inside operations teams at
            hospitals, distributors, and manufacturers. The pattern was always
            the same: the people closest to the work had the deepest
            expertise, and almost none of it lived in the systems that ran the
            organization.
          </p>
          <p>
            Inventory was tracked in spreadsheets a single person owned. RFQs
            were run from email. Reorder decisions were made from memory. When
            those people moved on, the institutional knowledge moved with
            them &mdash; leaving the organization exposed.
          </p>
          <p>
            We started <Brand /> to put that operational knowledge back into the
            organization, in a form auditors, executives, and the next person
            in the role can all trust. Every product we build follows the
            same three principles:
          </p>
          <ul className="principles-list">
            <li><strong>Reflect the work</strong> &mdash; software should mirror how operations actually run.</li>
            <li><strong>Capture at the source</strong> &mdash; the data is only as good as the moment it&rsquo;s recorded.</li>
            <li><strong>Make it auditable</strong> &mdash; every action defensible, every record exportable.</li>
          </ul>
        </div>
      </section>

      <section className="story-section">
        <h2 className="section-title">Work with us</h2>
        <div className="story-content">
          <p>
            If your team is running operations on spreadsheets, email, and
            tribal knowledge, we&rsquo;d like to talk.
          </p>
          <button className="hero-cta primary" onClick={goToDemo}>Talk to sales</button>
        </div>
      </section>
    </div>
  );
};

export default About;
